export type Point = [number, number]; //represent (x,y) coordinates
export type NumPair = [number, number]
export type Point3d = [number, number, number]
export type NumPair4 = [number, number, number, number]
export type Vector = [number, number, number]
export type Matrix = [Vector,Vector, Vector]
export type Vector2 = [number, number]

export module StringUtils{

    export function capitalizeFirstLetter(str : string) : string{
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

}

export module NumberUtils{
    export function fitToRange(val : number, min : number, max : number) : number{
        return (val < min ? min : (val > max ? max : val));
    }
    
    //accepts integers. min and max included in range
    export function rand(min : number, max : number) : number{
        return Math.floor( min + Math.random() * (max - min + 1) );
    }

    export function isWithinRange(val : number, min : number, max : number) : boolean{
        return val >= min && val <= max;
    }

    export function addToNumPair(val : number, numPair : NumPair) : NumPair{
        return [numPair[0] + val, numPair[1] + val];
    }

    export function isNumber(val: [number, number]) : Boolean{
        return ( Number(val[0])!=NaN && Number(val[1])!=NaN) ;
    }
}

export module CopyUtils{
    export function fromPoint(val: Point): Point{
        return [val[0], val[1]];
    }
    export function fromNumPair(val: NumPair): NumPair{
        return [val[0], val[1]];
    }
}